import axios from "axios"
import { useState } from "react"
import { Button, Form } from "react-bootstrap"
import { MapContainer, Marker, TileLayer, useMapEvents } from "react-leaflet"
import { toast } from "react-toastify"
import SearchIcon from '@mui/icons-material/Search';
import { toastOptions } from "../../config/toast"
import ContainedMuniSpinner from "../../components/MuniSpinner/ContainedMuniSpinner"
import HelperText from "../../components/HelperText"

const MapaActa = (props) => {
  const { register, errors, clearErrors, setValue } = props
  const [map, setMap] = useState(null)
  const [defaultMapPosition,] = useState([-38.951886, -68.059204])
  const [position, setPosition] = useState(null)
  const [geocoding, setGeocoding] = useState('')
  const [geocodingisLoading, setGeocodingIsLoading] = useState(false)

  function LocationMarker() {
    const map = useMapEvents({
      click(e) {
        clearErrors(['latitud', 'longitud'])
        setPosition(e.latlng)
        map.flyTo(e.latlng, map.getZoom(), 13)
        setValue('latitud', e.latlng.lat)
        setValue('longitud', e.latlng.lng)
      },
    })

    return position === null ? null : (
      <Marker position={position} />
    )
  }

  const runGeocoding = async () => {
    if (geocoding !== '') {
      setGeocodingIsLoading(true)
      const res = await axios.get(`https://geocode.maps.co/search?street=${geocoding}&city=Neuquen&country=AR`)
      if (res.data.length > 0) {
        const lat = res.data[0]?.lat
        const lng = res.data[0]?.lon
        map.flyTo([lat, lng], 17)
        setPosition({ lat: lat, lng: lng })
        clearErrors(['latitud', 'longitud'])
        setValue('latitud', lat)
        setValue('longitud', lng)
        toast.success(`Lugar encontrado: ${res.data[0]?.display_name}. En caso de ser incorrecto, seleccionar manualmente`, toastOptions)
      } else {
        toast.error('No se encontro la dirección solicitada', toastOptions)
      }
      setGeocodingIsLoading(false)
      return
    }
  }

  return (
    <div>
      <Form.Label>Lugar de la contravención *</Form.Label>
      <div className={'position-relative ' + ((errors.latitud || errors.longitud) && 'border rounded border-danger')} >
        <MapContainer style={{ height: '50vh', borderRadius: '0.375rem' }} center={defaultMapPosition} minZoom={7} zoom={13} attributionControl={false} ref={setMap}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <LocationMarker />
        </MapContainer>
        <div className="container_menu p-2 d-flex gap-x-2 position-absolute top-0 end-0 mt-4" style={{ zIndex: 9999, borderTopRightRadius: '0.375rem', borderBottomLeftRadius: '0.375rem' }} onClick={(e) => e.stopPropagation()}>
          <Form.Control placeholder="Buscar aproximación posible" onChange={(e) => { setGeocoding(e.target.value) }} onClick={(e) => e.stopPropagation()} style={{ width: '225px' }} />
          <Button className="ms-2" type="button" onClick={() => { runGeocoding() }}>
            {geocodingisLoading ? <ContainedMuniSpinner height={25} width={25} size={35} /> : <SearchIcon />}
          </Button>
        </div>
      </div>
      <input className="d-none" {...register('latitud')} />
      <input className="d-none" {...register('longitud')} />
      {(errors.latitud || errors.longitud) && (<p className="text-danger mb-0 mt-2">Debe seleccionar el lugar de la contravención</p>)}
      <HelperText className='mt-1 mb-1'>Por favor, verificar que el lugar de la contravención sea la correcta.</HelperText>
      <HelperText className='mt-1 mb-3'>Para cambiar la posición, haga click en el lugar deseado del mapa.</HelperText>
    </div>
  )


}

export default MapaActa